<template>
  <v-card outlined rounded="lg" class="pa-3 h-100">
    <div class="section-card-title">
      <v-icon color="#B3151B" class="mr-2">mdi-account-group</v-icon>
      ผู้เรียนแยกตามระดับชั้น
      <span class="section-card-count">{{ numberWithCommas(totalStudents) }} คน</span>
    </div>

    <div v-if="totalStudents > 0 && !isUnspecifiedOnly">
      <apexchart type="donut" height="280" :options="chartOptions" :series="series"></apexchart>
    </div>
    <div v-else-if="isUnspecifiedOnly" class="text-center grey--text pa-6">
      ข้อมูลต้นทางยังไม่ได้ระบุระดับชั้นแยกย่อยของสถานศึกษานี้
    </div>
    <div v-else class="text-center grey--text pa-6">ไม่พบข้อมูลนักเรียนของสถานศึกษานี้</div>
  </v-card>
</template>

<script>
// รับข้อมูลจาก parent (collegesid.vue) ซึ่ง fetch student_stat_summary_college.php ครั้งเดียวแล้วส่งต่อให้
// ทุก widget ที่เกี่ยวกับนักเรียน (stdLevel/stdBranch/stdminor/collegemajor) ใช้ร่วมกัน — เดิมแต่ละ widget
// เรียก endpoint เดียวกันด้วยพารามิเตอร์เดียวกันแยกกันเอง (4 ครั้งซ้ำซ้อนต่อการเปิดหน้า 1 ครั้ง)
export default {
  name: "DashboardOvecMasterStdLevel",
  props: {
    rows: { type: Array, default: () => [] }
  },
  computed: {
    byGrade() {
      const map = {};
      this.rows.forEach(r => {
        const grade = r.gradeNameTh || "ไม่ระบุระดับชั้น";
        map[grade] = (map[grade] || 0) + (parseInt(r.cnt) || 0);
      });
      return map;
    },
    totalStudents() {
      return Object.values(this.byGrade).reduce((a, b) => a + b, 0);
    },
    // ข้อมูลต้นทางบางสถานศึกษาไม่มี gradeNameTh เลย — ถ้าทุกแถวตกเป็น "ไม่ระบุระดับชั้น" หมด
    // (โดนัท 1 ชิ้น 100%) ไม่มีประโยชน์ในการสื่อสาร ให้แจ้งว่าไม่มีข้อมูลแทนการวาดกราฟเปล่าๆ
    isUnspecifiedOnly() {
      const keys = Object.keys(this.byGrade);
      return keys.length === 1 && keys[0] === "ไม่ระบุระดับชั้น";
    },
    series() {
      return Object.values(this.byGrade);
    },
    chartOptions() {
      const grades = Object.keys(this.byGrade);
      return {
        chart: { type: "donut" },
        labels: grades.map(g => g + " : " + this.numberWithCommas(this.byGrade[g])),
        colors: ["#B3151B", "#1B365D", "#A86400", "#424242", "#8E1014", "#9E9E9E"],
        legend: { position: "bottom", fontFamily: "Kanit" },
        dataLabels: { formatter: val => val.toFixed(1) + "%" }
      };
    }
  },
  methods: {
    numberWithCommas(x) {
      x = String(x);
      const pattern = /(-?\d+)(\d{3})/;
      while (pattern.test(x)) x = x.replace(pattern, "$1,$2");
      return x;
    }
  }
};
</script>

<style scoped>
.h-100 {
  height: 100%;
}
.section-card-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-weight: 700;
  color: #1b365d;
  font-size: 1rem;
  margin-bottom: 8px;
}
.section-card-count {
  margin-left: auto;
  font-weight: 700;
  color: #b3151b;
}
</style>
